import { render } from "./Layout.vue?vue&type=template&id=2ab51da9"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/Layout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ab51da9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ab51da9', __exports__)) {
    api.reload('2ab51da9', __exports__)
  }
  
  module.hot.accept("./Layout.vue?vue&type=template&id=2ab51da9", () => {
    api.rerender('2ab51da9', render)
  })

}


export default __exports__